import FormikStripe from 'shared/components/molecules/FormikStripe/FormikStripe';

export default FormikStripe;
